import React, { useCallback, useMemo } from 'react';
import { injectIntl } from 'react-intl';

import {
  Row,
  Col,
  Button,
  Card,
  Input,
  Form,
} from 'antd';

import {managerValidation as validation} from './validation';
import useForm from 'utils/useForm';

import './style.less';

const ManagerForm = ({
  intl,
  type,
  record,
  index,
  onSave,
  onCancel,
}) => {
  const t = intl.messages;
  const defaults = record;
  const validateForm = useMemo(() => validation(t), [ t ]);

  const submitForm = () => {
    const { name, email, position, department } = values;
    onSave(
      type, index, { name, email, position, department }
    );
  };

  const {
    values,
    handleChangeEvent,
    handleSubmit,
    isDirty,
    errors,
  } = useForm({
    callback: submitForm,
    validate: validateForm,
    defaultValues: defaults,
  });

  const getValue = useCallback(
    (name) => (typeof values[name] === 'undefined' ? defaults[name] : values[name]),
    [values, defaults]
  );
  const showError = useCallback(
    (name) => (!isDirty(name) && errors[name]) || '',
    [isDirty, errors]
  );

  return (
    <Row>
      <Col span={24} className="form-input-wrapper">
        <Card className="form-input-card">
          <Row gutter={10}>
            <Col span={24}>
              <Form.Item
                hasFeedback
                validateStatus={ showError('concept') ? 'error' : '' }
                help={ showError('name') }
                label={ t.responsible_name }
                colon={false}
                required
              >
                <Input
                  placeholder={ t.responsible_name }
                  name="name"
                  value={ getValue('name') }
                  onChange={handleChangeEvent}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                hasFeedback
                validateStatus={ showError('email') ? 'error' : '' }
                help={ showError('email') }
                label={ t.responsible_email }
                colon={false}
              >
                <Input
                  placeholder={ t.responsible_email }
                  name="email"
                  value={ getValue('email') }
                  onChange={handleChangeEvent}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                hasFeedback
                validateStatus={ showError('position') ? 'error' : '' }
                help={ showError('position') }
                label={ t.position }
                colon={false}
                required
              >
                <Input
                  placeholder={ t.position }
                  name="position"
                  value={ getValue('position') }
                  onChange={handleChangeEvent}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                hasFeedback
                validateStatus={ showError('department') ? 'error' : '' }
                help={ showError('department') }
                label={ t.department }
                colon={false}
                required
              >
                <Input
                  placeholder={ t.department }
                  name="department"
                  value={ getValue('department') }
                  onChange={handleChangeEvent}
                />
              </Form.Item>
            </Col>
            <Col span={2}>
              <Button
                  type="primary"
                  onClick={handleSubmit}
                >
                  { t.add }
              </Button>
            </Col>
            <Col span={2}>
              <Button onClick={() => onCancel(type, index)}>
                { t.cancel }
              </Button>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  )
};

export default injectIntl(ManagerForm);
